<template>
  <b-collapse
    :id="`bundling-${String(data.index)}`"
    @shown="onShown"
  >
    <div class="border-l-[2px] h-min p-[16px] ml-[3.5rem]">
      <BundleVarianInWarehouseDetail
        v-if="data.item.is_bundle_varian"
        ref="bundleVarianInWarehouseDetail"
        :product-id="data.item.product_id"
      />
      <div
        v-else
        class="border rounded-t w-[80%]"
      >
        <div class="bg-[#FFECE9] py-[8px] px-[28px] rounded-t text-black font-[500]">
          Produk
        </div>
        <b-table
          :items="data.item.bundle_component"
          :fields="fieldsBundling"
        >
          <template #cell(no)="cell">
            {{ cell.index + 1 }}
          </template>
          <template #cell(product_name)="cell">
            <div class="flex gap-[16px] items-start">
              <img
                :src="cell.item.product_image[0] ? cell.item.product_image[0].images_path : 'https://storage.googleapis.com/komerce/assets/icons/product-placehold.svg'"
                alt="product"
                width="52"
                height="52"
              >
              <div class="space-y-[4px]">
                <div class="font-medium">
                  {{ cell.item.product_name }}
                </div>
                <div class="text-primary text-[12px]">
                  SKU: {{ cell.item.sku }}
                </div>
              </div>
            </div>
          </template>
        </b-table>
      </div>
    </div>
    <div class="flex ml-[0.8rem]">
      <div
        v-b-toggle="`bundling-${String(data.index)}`"
        class="flex items-center gap-[4px] py-[4px] px-[8px] rounded-[12px] !bg-[#F95031] text-white font-[500] cursor-pointer"
      >
        <feather-icon
          icon="ChevronUpIcon"
        />
        <div>Tutup</div>
      </div>
    </div>
  </b-collapse>
</template>

<script>
/**
 * Component untuk menampilkan detail bundle varian di page Gudangku > Gudang Mitra Kompack > Detail Gudangku
 * @param {Object} data - Data item produk
 */
import BundleVarianInWarehouseDetail from './BundleVarianInWarehouseDetail.vue'
import { fieldsBundling } from '../config'

export default {
  components: {
    BundleVarianInWarehouseDetail,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isOpen: false,
      fieldsBundling,
    }
  },
  methods: {
    /**
     * Event handler untuk trigger behavior saat collapse di-open
     */
    onShown() {
      // trigger fetch detail bundle varian (lazy loading)
      if (this.$refs.bundleVarianInWarehouseDetail) {
        this.$refs.bundleVarianInWarehouseDetail.fetchDetailBundleVarian()
      }
    },
  },
}
</script>
